import { SubjectPermissionActions } from './SubjectPermissionActions';
export default SubjectPermissionActions;